import template from './merge-account.jade';
import validation from '../../../scripts/services/validation';

export default () => {
  return {
    require: ['cianAfMergeAccount', 'form'],
    bindToController: {
      mergeData: '=',
      enterEmailData: '=',
    },
    link: (scope, element, attrs, ctrls) => {
      ctrls[0].init(ctrls[1]);
    },
    template,
    controller(
      $scope,
      apiService,
      analyticsService,
      remoteValidationService,
      popupService,
      authService,
      deviceService,
    ) {
      'ngInject';

      this.isMobile = deviceService.isMobile;

      const sendAuthAnalytics = (isLogin, type) => {
        if (authService.isLastStepLogin) {
          if (isLogin) {
            analyticsService.successfulSocLogin(type);
          } else {
            analyticsService.successfulSocRegistration(type);
          }
        } else {
          const parsedType = type === 'mailru' ? 'mail' : type;

          if (isLogin) {
            analyticsService.successSocialAuth(parsedType);
          } else {
            analyticsService.successSocialRegister(parsedType);
          }
        }
      };

      this.password = '';

      this.init = form => {
        this.clearForm = () => {
          this.password = '';
          form.$setPristine();
          form.password.$setUntouched();
        };

        this.forgotPassword = () => {
          this.clearForm();
          this.remindPassword = true;
          analyticsService.forgotPassword();
        };

        this.passIsShown = false;

        this.togglePassVisible = () => {
          this.passIsShown = !this.passIsShown;
        };

        this.passwordValidation = validation(form, 'password', {
          required: 'Пароль не заполнен',
        });

        form.remoteValidator = remoteValidationService.getInstance(form);
        form.remoteValidator.map = data => {
          const result = {
            fields: {},
            form: {},
            sections: {},
          };

          if (data.key === 'password') {
            result.fields.password = {
              triggers: 'password',
              messages: { code: 'invalidPassword' },
            };
          }

          return result;
        };

        this.showError = options => {
          const popupData = options || {};
          popupService.openPopup('authError', { popupData });
        };

        this.createNewUser = () => {
          if (!this.submiting) {
            this.clearForm();
            this.submiting = true;
            const data = {
              socialLoginId: this.mergeData.socialLoginId,
            };
            apiService
              .generateFakeEmail(data)
              .then(generateMailResponse => {
                const data = {
                  socialLoginId: this.mergeData.socialLoginId,
                  email: generateMailResponse.data.email,
                };

                return apiService.socialMergeNew(data);
              })
              .then(mergeResponse => {
                const data = {
                  socialLoginId: mergeResponse.data.socialLoginId,
                  email: mergeResponse.data.email,
                  token: mergeResponse.data.token,
                };

                return apiService.socialLogin(data);
              })
              .then(() => {
                const { type } = this.mergeData;
                sendAuthAnalytics(false, type);

                return authService.getUserData();
              })
              .catch(response => {
                this.submiting = false;
                const error = response.data.errors[0];
                this.showError({ message: error.message });
              });
          }
        };

        this.submiting = false;
        this.submit = () => {
          form.password.$setTouched();
          this.submiting = true;

          const data = {
            socialLoginId: this.mergeData.socialLoginId,
            email: this.mergeData.mergeEmail,
            password: this.password,
          };
          apiService
            .socialMerge(data)
            .then(response => {
              analyticsService.successMergeAccount(this.mergeData.type);
              const data = {
                socialLoginId: response.data.socialLoginId,
                email: response.data.email,
                token: response.data.token,
              };

              return apiService.socialLogin(data);
            })
            .then(() => {
              const { type } = this.mergeData;
              sendAuthAnalytics(true, type);

              return authService.getUserData();
            })
            .catch(response => {
              this.submiting = false;
              const error = response.data.errors[0];
              if (error.key === 'password') {
                form.remoteValidator.setValidators(error);
              } else {
                this.showError({ message: error.message });
              }
            });
        };
      };
    },
    controllerAs: 'mergeAccountCtrl',
    replace: true,
  };
};
